export default "__VITE_PUBLIC_ASSET__c42e9ad8__"